import { useState } from "react";
import { Clock, Landmark, Fingerprint, Users, Building2, Wallet, MessageSquareText } from "lucide-react";
import { useT } from "@/i18n";
import { useAuth } from "@/context/AuthContext";
import AttendanceRules from "@/pages/AttendanceRules";
import { AdminAccount } from "@/pages/AccountCenter";
import BankMaster from "@/pages/BankMaster";
import FingerspotIntegration from "@/pages/FingerspotIntegration";
import { CompanyProfilePanel, PayrollRulesPanel, WhatsAppTemplatePanel } from "@/pages/SettingsPanels";

export default function Settings() {
  const { t } = useT();
  const { user } = useAuth();
  const [active, setActive] = useState("company");

  const sections = [
    { key: "company", icon: Building2, label: t("set.company") },
    { key: "attendance", icon: Clock, label: t("set.attendanceRules") },
    { key: "rules", icon: Wallet, label: t("set.payrollRules") },
    { key: "wa", icon: MessageSquareText, label: t("set.waTemplate") },
    { key: "accounts", icon: Users, label: t("set.accounts") },
    { key: "banks", icon: Landmark, label: t("set.banks") },
    { key: "integrations", icon: Fingerprint, label: t("set.integrations") },
  ];

  return (
    <div data-testid="settings-page" className="w-full">
      <div className="mb-6">
        <h1 className="text-[26px] font-semibold tracking-tight sm:text-[30px]">{t("set.title")}</h1>
        <p className="mt-1 text-[14px] text-[#8E8E93]">{t("set.subtitle")}</p>
      </div>

      <div className="flex flex-col gap-6 lg:flex-row">
        {/* Left navigator */}
        <nav className="shrink-0 lg:w-60">
          <div className="flex gap-2 overflow-x-auto pb-1 lg:sticky lg:top-24 lg:flex-col lg:gap-1 lg:overflow-visible lg:pb-0">
            {sections.map(({ key, icon: Icon, label }) => (
              <button
                key={key}
                data-testid={`settings-nav-${key}`}
                onClick={() => setActive(key)}
                className={`flex shrink-0 items-center gap-2.5 rounded-xl px-4 py-2.5 text-left text-[14px] font-medium transition-all ${
                  active === key
                    ? "bg-[#0071E3] text-white shadow-[0_6px_18px_rgba(0,113,227,0.28)]"
                    : "text-[#3A3A3C] hover:bg-black/[0.05]"
                }`}
              >
                <Icon className="h-4 w-4 shrink-0" />
                <span className="whitespace-nowrap lg:whitespace-normal">{label}</span>
              </button>
            ))}
          </div>
        </nav>

        {/* Content */}
        <div className="min-w-0 flex-1">
          {active === "company" && <CompanyProfilePanel />}
          {active === "attendance" && <AttendanceRules />}
          {active === "rules" && <PayrollRulesPanel />}
          {active === "wa" && <WhatsAppTemplatePanel />}
          {active === "accounts" && <AdminAccount user={user} />}
          {active === "banks" && <BankMaster />}
          {active === "integrations" && <FingerspotIntegration />}
        </div>
      </div>
    </div>
  );
}
